import HomeCardPlaceHolder from '@spotahome/marketplace-common/src/components/Homecard/HomeCardPlaceHolder';
import { useMediaQuery } from '@spotahome/ui-library/src/tenant/components/utils/breakpoints/breakpoints';
import classNames from 'classnames';

const EMPTY_LIST_LENTGH_BY_DEVICE = {
  default: 8,
  desktop: 12,
  wide: 12
};

const EmptyList = ({ isReduceMapPresenceExperiment = false }) => {
  const { device } = useMediaQuery();
  const emptyListLength =
    EMPTY_LIST_LENTGH_BY_DEVICE[device] || EMPTY_LIST_LENTGH_BY_DEVICE.default;

  const itemClasses = classNames('l-list__item', {
    'l-list__item--without-map': isReduceMapPresenceExperiment
  });

  return (
    <div className="l-list" style={{ margin: 0 }}>
      {new Array(emptyListLength).fill().map((_, i) => (
        <div className={itemClasses} key={i}>
          <HomeCardPlaceHolder />
        </div>
      ))}
    </div>
  );
};

export default EmptyList;
